module.exports = __webpack_public_path__ + "static/media/13_shape_r.b0b5ecec.webp";